import React, { useState } from 'react';

type Props = {
  defaultEnableEntryFilter: boolean;
  defaultFilterEarningsBeforeBds: string; // 0-10 ("0" means same day)
  defaultFilterEarningsAfterBds: string;  // 0-10 ("0" means same day)
};

const EntryFilterFields: React.FC<Props> = ({
  defaultEnableEntryFilter,
  defaultFilterEarningsBeforeBds,
  defaultFilterEarningsAfterBds,
}) => {
  const [enableEntryFilter, setEnableEntryFilter] = useState<boolean>(defaultEnableEntryFilter);
  const [beforeBds, setBeforeBds] = useState<string>(defaultFilterEarningsBeforeBds);
  const [afterBds, setAfterBds] = useState<string>(defaultFilterEarningsAfterBds);

  const beforeOptions = Array.from({ length: 11 }, (_, i) => ({
    value: i.toString(),
    label: i === 0 ? '当日' : `${i}営業日前`,
  }));

  const afterOptions = Array.from({ length: 11 }, (_, i) => ({
    value: i.toString(),
    label: i === 0 ? '当日' : `${i}営業日後`,
  }));

  return (<>
    <div className="form-check">
      <label className="form-check-label">
        <input
          className="form-check-input"
          type="checkbox"
          checked={enableEntryFilter}
          onChange={() => setEnableEntryFilter(!enableEntryFilter)}
        />
        決算発表日の前後でエントリーを停止する
      </label>
    </div>

    {enableEntryFilter && (
      <div className="input-group">
        <span className="input-group-text">決算発表日</span>
        <select
          className="form-control"
          onChange={(e) => setBeforeBds(e.target.value)}
        >
          {beforeOptions.map((opt) => (
            <option key={opt.value} value={opt.value} selected={beforeBds === opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <span className="input-group-text">から</span>
        <select
          className="form-control"
          onChange={(e) => setAfterBds(e.target.value)}
        >
          {afterOptions.map((opt) => (
            <option key={opt.value} value={opt.value} selected={afterBds === opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <span className="input-group-text">まで</span>
      </div>
    )}

    {enableEntryFilter ? (
      <>
        <input type="hidden" name="subscription[enable_entry_filter]" value="1" />
        <input type="hidden" name="subscription[filter_earnings_before_bds]" value={beforeBds} />
        <input type="hidden" name="subscription[filter_earnings_after_bds]" value={afterBds} />
      </>
    ) : (
      <input type="hidden" name="subscription[enable_entry_filter]" value="0" />
    )}
  </>);
};

export default EntryFilterFields;
